import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../app/store";
import { useEffect, useMemo } from "react";
import { listContractProducts } from "../../products/productsSlice";
import { SelectorOptionType } from "../../../components/ViewOnlySelector";

export const useProductOption = () => {
  const wholeState = useTypedSelector((x) => ({
    ...x.login,
    ...x.products,
  }));
  const dispatch = useDispatch();

  const productOptions = useMemo(
    () =>
      wholeState.products.map((product) => ({
        value: product.productId,
        label: product.productName,
      })) as SelectorOptionType[],
    [wholeState.products]
  );

  useEffect(() => {
    dispatch(listContractProducts({ accessToken: wholeState.accessToken! }));
    return () => {};
  }, [dispatch, wholeState.accessToken]);

  return { productOptions };
};
